export default __webpack_public_path__ + "static/service_02-c38299aee1743f476ce671a4abcd3353.jpg";